const FRIDAY_APPID_MAP = {
  DEV: '4ae975f94eeac53d4270161e485e9b0d',
  TEST: '7aff02261041f4d74b275ab856938e03',
  PRO: 'cb1f57e93cae99f846182126c40c391f'
};

export default FRIDAY_APPID_MAP;
